import { Badge, Card } from "react-bootstrap";
import { FaCamera, FaCheck, FaChevronRight, FaCloudUploadAlt, FaImages, FaMapMarkerAlt, FaPhone } from "react-icons/fa";
import { Link } from "react-router-dom";

function InspectionCard({ job, pending = 0, finishPending = false }) {
  const phone = job.mobile_phone || job.business_phone;
  // finishPending = finished on this device, not sent yet (a dead spot). The
  // server list cannot know about it, so the device's view wins here.
  const finished = !!job.has_been_inspected || finishPending;
  return (
    <Card className={`shadow-sm border-0 h-100${finished ? " opacity-75" : ""}`}>
      <Card.Body className="d-flex flex-column gap-2">
        <div className="d-flex align-items-start gap-2">
          <div className="flex-grow-1">
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <h2 className="h5 mb-0">Job #{job.claim_number}</h2>
              {finished ? (
                finishPending ? (
                  <Badge bg="warning" text="dark"><FaCloudUploadAlt className="me-1" />Finished · waiting to send</Badge>
                ) : (
                  <Badge bg="success"><FaCheck className="me-1" />Finished</Badge>
                )
              ) : null}
              {pending ? <Badge bg="warning" text="dark"><FaCamera className="me-1" />{pending} waiting</Badge> : null}
              {job.photo_count ? (
                <Badge bg="secondary"><FaImages className="me-1" />{job.photo_count}</Badge>
              ) : null}
            </div>
            <div className="fw-semibold mt-1">{job.client_name || job.contact_name || "Unnamed client"}</div>
          </div>
          <FaChevronRight className="text-body-secondary mt-1" />
        </div>
        {job.street_address ? (
          <div className="small"><FaMapMarkerAlt className="me-2 text-body-secondary" />{job.street_address}</div>
        ) : null}
        {phone ? (
          <div className="small"><FaPhone className="me-2 text-body-secondary" />{phone}</div>
        ) : null}
        {job.notes_for_inspector ? (
          <div className="small bg-body-tertiary rounded p-2 text-break">{job.notes_for_inspector}</div>
        ) : null}
        <Link
          className={`btn mt-auto stretched-link ${finished ? "btn-outline-secondary" : "btn-primary"}`}
          to={`/inspection/${job.inspection_id}`}
          aria-label={`Open job ${job.claim_number}`}
        >
          {finished ? "View Inspection" : "Open Inspection"}
        </Link>
      </Card.Body>
    </Card>
  );
}

export default InspectionCard;
